import React, { SFC } from 'react';
import styled, { withTheme } from 'styled-components';
import cx from 'classnames';
import { colors } from '../../styles';
import { Checkbox } from '../../atoms/inputs';
import { SelectableListTheme, SelectableListItem } from './types';

export interface Props {
  theme?: SelectableListTheme;
  item: SelectableListItem;
  disabled: boolean;
  handleSelect: any;
  isSelected: any;
  depth: number;
  filter: string;
}

const SelectableRow: SFC<Props> = ({
  item,
  theme,
  disabled,
  handleSelect,
  isSelected,
  depth,
  filter,
}) => {
  const { nestedListProperty } = theme;

  if (isSelected(item.id) && disabled) {
    handleSelect(item.id)();
  }

  return (
    <Wrapper
      theme={theme}
      depth={depth}
      className={cx({
        selected: isSelected(item.id) || disabled,
        'read-only': item.readOnly,
      })}
    >
      {(filter && item.name.toLowerCase().includes(filter)) || !filter ? (
        <section
          className={cx('item', {
            selected: isSelected(item.id) || disabled,
            disabled,
          })}
        >
          <Checkbox
            className="checkbox"
            disabled={disabled}
            checked={isSelected(item.id) || disabled}
            onChange={!item.readOnly && handleSelect(item.id)}
          />
          <div>{item.name}</div>
        </section>
      ) : null}
      <section className="list">
        {item[nestedListProperty] &&
          !!item[nestedListProperty].length &&
          item[nestedListProperty].map(d => (
            <SelectableRow
              key={d.id}
              item={d}
              disabled={isSelected(item.id) || disabled}
              handleSelect={handleSelect}
              isSelected={isSelected}
              depth={depth + 1}
              theme={theme}
              filter={filter}
            />
          ))}
      </section>
    </Wrapper>
  );
};

const calculatePadding = ({ theme, depth }: Partial<Props>) =>
  `${theme.indent * depth}rem`;

const Wrapper = styled.div`
  &.selected {
    background: ${colors.green10};
  }
  &.read-only {
    > .item {
      .checkbox {
        pointer-events: none;
      }
      opacity: 0.3;
    }
  }

  > .item {
    padding-left: ${calculatePadding};
    display: flex;
    align-items: center;
    height: 3rem;

    > div {
      padding-left: 1rem;
    }
    &.selected {
      background: ${colors.green10};
      color: ${colors.green500};
    }
    &.disabled {
      .checkbox {
        opacity: 0.3;
      }
    }
  }
`;

export default withTheme(SelectableRow);
